module.exports = __webpack_public_path__ + "static/pattern-94c5521604e55770f5423f9172458160.png";